export const ROLE_ITEMS = ['user', 'partner', 'salesAdmin', 'admin'] as const;

export type AllowedRole = (typeof ROLE_ITEMS)[number];

type UserWithRoles = {
  isAdmin?: boolean;
  isSalesAdmin?: boolean;
  isPartner?: boolean;
};

export function userSatisfiesRole(
  user: UserWithRoles,
  role: AllowedRole,
): boolean {
  if (role === 'user') return true;
  if (user.isAdmin) return true;
  if (role === 'partner') return !!user.isPartner;
  if (role === 'salesAdmin') return !!user.isSalesAdmin;

  return false;
}
